const STEPS = [
    {
        num: 1,
        color: '#ED5C2F',
        title: 'Scoping call',
        desc: '20 minutes. We review your product, your users, the formats you want to offer, and how mail should fit your pricing.',
    },
    {
        num: 2,
        color: '#F28230',
        title: 'Brand + templates',
        desc: 'We skin the builder to your brand and load the industry templates that fit your user base, so it looks and reads like your product.',
    },
    {
        num: 3,
        color: '#FAB331',
        title: 'Embed and go live',
        desc: 'You drop the builder and mail flow into your app. Your users design a piece, pick an audience, and hit send.',
    },
    {
        num: 4,
        color: '#3F454F',
        title: 'Track and report',
        desc: 'Mail piece tracking, call tracking, QR codes, and response data flow back so your users see what their mail did.',
    },
]

export default function HowItWorks() {
    return (
        <section className="bg-[#FFF7EC]">
            <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 lg:py-16">
                <div className="flex flex-col gap-4 max-w-3xl mb-10">
                    <span className="text-secondary text-xs uppercase tracking-widest font-semibold">
                        How the integration works
                    </span>
                    <h2
                        className="text-[#3F454F] tracking-tight text-3xl md:text-[44px] font-bold"
                        style={{ lineHeight: 1.05 }}>
                        Launch direct mail in your product
                    </h2>
                    <h2
                        className="-mt-3 pb-1 tracking-tight text-3xl md:text-[44px] font-bold bg-clip-text text-transparent"
                        style={{
                            lineHeight: 1.05,
                            backgroundImage:
                                'linear-gradient(to right, #ED5C2F 10%, #F28230 35%, #FAB331 65%)',
                        }}>
                        without building any of it.
                    </h2>
                    <p
                        className="text-[#3F454F]/70 text-lg"
                        style={{ lineHeight: '28px' }}>
                        We start with how your users work today, then wire the
                        builder and mail flow into your product so it feels
                        native.
                    </p>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-4 gap-5">
                    {STEPS.map((step) => (
                        <div
                            key={step.num}
                            className="group flex flex-col gap-3 p-7 bg-white rounded-2xl border border-gray-200/50 transition-all duration-300 ease-out hover:-translate-y-1 hover:shadow-lg hover:border-secondary/30">
                            <div
                                className="w-9 h-9 rounded-lg flex items-center justify-center transition-transform duration-300 ease-out group-hover:scale-110"
                                style={{ backgroundColor: step.color }}>
                                <span className="text-white font-bold">
                                    {step.num}
                                </span>
                            </div>
                            <h3
                                className="text-[#3F454F] font-bold text-xl md:text-[25px]"
                                style={{ lineHeight: '28px' }}>
                                {step.title}
                            </h3>
                            <p className="text-sm text-[#3F454F]/65">
                                {step.desc}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
